import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { debounce } from 'lodash';

import DynamicForm from '../../../components/DynamicForm';
import FormTextField from '../../../components/DynamicForm/FormTextField';
import UpdateForm, { STATE } from '../../../components/CreateOrUpdateForm';
import { extractRequiredFieldKeys } from '../../../components/DynamicForm/utils';

import styles from './Details.module.scss';


interface DetailsSectionProps {
    inspectorTheme?: boolean;
    formTemplate: any;
    onChange: (_value: any) => void;
};

const DetailsSection = ({ inspectorTheme = false, formTemplate, onChange }: DetailsSectionProps) => {
    const { t } = useTranslation();
    const [showFormPopup, setShowFormPopup] = useState<boolean>(false);
    const [currFormName, setCurrFormName] = useState<string>('');
    const [currFormTemplate, setCurrFormTemplate] = useState<any>(formTemplate);

    const debouncedChange = useCallback(
        debounce((payload: any) => {
            onChange(payload);
        }, 500), []
    );

    const onChangeName = (name: string) => {
        setCurrFormName(name);
        debouncedChange({ ...currFormTemplate, name });
    };

    const applyFormTemplateChanges = (data: any) => {
        const payload = {
            name: data.name,
            type: data.type,
            optional: data.optional,
            schema: {
                required: extractRequiredFieldKeys(data.uiSchema),
                ...data.schema,
            },
            styling: data.uiSchema,
        };
        setCurrFormName(data.name);
        setCurrFormTemplate(payload);
        setShowFormPopup(false);
        onChange(payload);
    };

    useEffect(() => {
        setCurrFormName(formTemplate.name);
        setCurrFormTemplate(formTemplate);
    }, [formTemplate])

    return (
        <div className={`${styles.sectionContainer} ${inspectorTheme ? styles.sectionContainerInpsectorTheme : ''}`}>
            <div className={styles.sectionTop}>
                <Button
                    variant="contained"
                    color="primary"
                    style={{ padding: '6px 16px' }}
                    onClick={() => setShowFormPopup(true)}
                    disabled={false}
                >
                    {t('COMMON_EDIT_FORM')}
                </Button>
            </div>
            <div className={styles.sectionContent}>
                <div className={styles.formTitle}>
                    <FormTextField
                        id="name-of-form"
                        title={t('INSPECT_MEDIA_MINI_FORM_NAME')}
                        label={true}
                        isRequired={true}
                        value={currFormName}
                        onChange={(_, val) => onChangeName(val)}
                    />
                </div>
                <div className={styles.formTitle}>{t('COMMON_FORM_FIELDS')}</div>
                <DynamicForm
                    className={styles.formContent}
                    schema={currFormTemplate.schema}
                    uiSchema={currFormTemplate.styling}
                />
            </div>
            <UpdateForm
                open={showFormPopup}
                state={STATE._UPDATE}
                formTemplate={currFormTemplate}
                onClose={() => setShowFormPopup(false)}
                onSubmit={applyFormTemplateChanges}
            />
        </div>
    );
};

export default DetailsSection;
